export class ServerAddress {

    private static _instance:ServerAddress = new ServerAddress();

    private _value = '';

    constructor() {
        if(ServerAddress._instance) {
            throw new Error('Error: Instantiation failed: Use SingletonDemo.getInstance() instead of new.');
        }
        ServerAddress._instance = this;
    }

    public static getInstance():ServerAddress {
        return ServerAddress._instance;
    }

    public setValue(value:string):void {
        this._value = value;
    }

    public getValue():string {
        return this._value;
    }


}
